module.exports = __webpack_public_path__ + "img/NY_Bagel_Avocado_Toast_2.31f16da9.jpg";